import * as React from 'react';
import { Spinner } from '@fluentui/react-components';
import loadable from '@loadable/component';
import Layout from '../layouts/LoggedIn';
import type { RedirectProps, RouteProps } from '.';

/* istanbul ignore file */

const Loading = <Spinner size="large" />;

export const routes: Array<RouteProps> = [
  {
    path: '/benefits/history',
    component: loadable(() => import(/* webpackChunkName: "benefits" */ '../pages/RedeemedBenefits'), {
      fallback: Loading,
    }),
    layout: Layout,
  },
  {
    path: '/benefits',
    component: loadable(() => import(/* webpackChunkName: "benefits" */ '../pages/Benefits'), { fallback: Loading }),
    layout: Layout,
  },
  {
    path: '/benefits/vs-studio',
    component: loadable(
      () => import(/* webpackChunnkName: "visualstudio" */ '../pages/Benefits/VisualStudio/ManageVisualStudio'),
      { fallback: Loading }
    ),
    layout: Layout,
  },
  {
    path: '/settings/company/:companyId',
    component: loadable(() => import(/* webpackChunkName: "company-profile-detail" */ '../pages/CompanyDetail'), {
      fallback: Loading,
    }),
    layout: Layout,
  },
  {
    path: '/settings',
    component: loadable(() => import(/* webpackChunkName: "settings" */ '../pages/Settings'), { fallback: Loading }),
    layout: Layout,
  },
  {
    path: '/go-to-market',
    component: loadable(() => import(/* webpackChunkName: "go-to-market" */ '../pages/GoToMarket'), {
      fallback: Loading,
    }),
    layout: Layout,
  },
  {
    path: ['/', '/task/redeem-benefit/:slug', '/redeem-benefit/:slug'],
    exact: true,
    component: loadable(() => import(/* webpackChunkName: "company-profile" */ '../pages/CompanyProfile'), {
      fallback: Loading,
    }),
    layout: Layout,
  },
];

export const redirects: Array<RedirectProps> = [
  { from: '/signup', to: '/apply' },
  { from: '/company-profile', to: '/' },
];

export const NotFound = loadable(() => import(/* webpackChunkName: "404-in" */ '../pages/NotFound/LoggedIn'), {
  fallback: Loading,
});
